module.exports = __webpack_public_path__ + "img/quayThresholdToVehicle.f87ed3e4.svg";